import * as types from './actionTypes';

// Fetch Multilevel Approval
export const fetchMultilevelApprovalRequest = (unit_id) => ({
  type: types.FETCH_MULTILEVEL_APPROVAL_REQUEST,
  payload: { unit_id },
});

export const fetchMultilevelApprovalSuccess = (data) => ({
  type: types.FETCH_MULTILEVEL_APPROVAL_SUCCESS,
  payload: data,
});

export const fetchMultilevelApprovalFailure = (error) => ({
  type: types.FETCH_MULTILEVEL_APPROVAL_FAILURE,
  payload: error,
});

// Save Multilevel Approval
export const saveMultilevelApprovalRequest = (payload) => ({
  type: types.SAVE_MULTILEVEL_APPROVAL_REQUEST,
  payload,
});

export const saveMultilevelApprovalSuccess = (data) => ({
  type: types.SAVE_MULTILEVEL_APPROVAL_SUCCESS,
  payload: data,
});

export const saveMultilevelApprovalFailure = (error) => ({
  type: types.SAVE_MULTILEVEL_APPROVAL_FAILURE,
  payload: error,
});

export const toggleApprovalStatusRequest = (payload) => ({
  type: types.TOGGLE_APPROVAL_STATUS_REQUEST,
  payload,
});

export const toggleApprovalStatusSuccess = (data) => ({
  type: types.TOGGLE_APPROVAL_STATUS_SUCCESS,
  payload: data,
});

export const toggleApprovalStatusFailure = (error) => ({
  type: types.TOGGLE_APPROVAL_STATUS_FAILURE,
  payload: error,
});